import { useEffect, useState } from "react";
import {
  changeMetaWhatsappStatus,
  changePushNotificationStatus,
  changeVoiceNotificationStatus,
  messagesList,
  SendPushNotification,
  studentAppShare,
  updatePushNotification,
} from "../../api/Messages";
import { closeModal, LoadingDiv, SweetAlertShow } from "../master/Master";
import Header from "../master/SideBar";
import Nav from "../master/NavBar";
import Master from "./Master";
import { formatToDateTime } from "../master/FormatToDateTime";
import { Link } from "react-router-dom";

export default function MessagesList() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [modalData, setModalData] = useState({});
  const [testPushData, setTestPushData] = useState({
    type: "",
    user_id: "",
  });

  const getList = async () => {
    setLoading(true);

    try {
      const response = await messagesList();

      if (response?.data?.data) {
        setData(response.data.data);
      } else {
        SweetAlertShow(
          "info",
          "Warning",
          response?.data?.message || "No data found",
        );
      }
    } catch (err) {
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ?? err?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getList();
  }, []);

  const handlePushNotificationStatusChange = async (id) => {
    setLoading(true);
    try {
      const response = await changePushNotificationStatus(id);
      if (response?.data?.status) {
        SweetAlertShow("success", "Successfully", response?.data?.message);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (err) {
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ?? err?.message,
      );
    } finally {
      setLoading(false);
      getList();
    }
  };

  const handleMetaWhatsappStatusChange = async (id) => {
    setLoading(true);
    try {
      const response = await changeMetaWhatsappStatus(id);
      if (response?.data?.status) {
        SweetAlertShow("success", "Successfully", response?.data?.message);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (err) {
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ?? err?.message,
      );
    } finally {
      setLoading(false);
      getList();
    }
  };
  const handleAppShare = async () => {
    setLoading(true);
    try {
      const response = await studentAppShare();
      if (response?.data?.status) {
        SweetAlertShow("success", "Successfully", response?.data?.message);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (err) {
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ?? err?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const handlePushNotificationUpdate = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const formData = new FormData(e.target);
      const response = await updatePushNotification(formData);
      if (response?.data?.status) {
        closeModal("PushNotification");
        SweetAlertShow("success", "Successfully", response?.data?.message);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (err) {
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ?? err?.message,
      );
    } finally {
      setLoading(false);
      getList();
    }
  };

  const handleTestPushNotification = async () => {
    if (!testPushData.type) {
      SweetAlertShow("warning", "Warning", "Please Select Type");
      return;
    }

    if (!testPushData.user_id) {
      SweetAlertShow("warning", "Warning", "Please Enter User ID");
      return;
    }

    setLoading(true);

    try {
      const response = await SendPushNotification({
        type: testPushData.type,
        user_id: testPushData.user_id,
        title: modalData.push_notification_header,
        description: modalData.push_notification_message,
        slug: modalData.slug,
      });

      if (response?.data?.status) {
        closeModal("TestPushNotification");
        SweetAlertShow("success", "Success", response?.data?.message);
      } else {
        SweetAlertShow("warning", "Warning", response?.data?.message);
      }
    } catch (err) {
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ?? err.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const handleVoiceNotificationStatusChange = async (id) => {
    setLoading(true);

    try {
      const response = await changeVoiceNotificationStatus(id);

      if (response?.data?.status) {
        SweetAlertShow(
          "success",
          "Successfully",
          response?.data?.message
        );
      } else {
        SweetAlertShow(
          "info",
          "Warning",
          response?.data?.message
        );
      }
    } catch (err) {
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ?? err?.message
      );
    } finally {
      setLoading(false);
      getList();
    }
  };

  return (
    <>
      {loading && <LoadingDiv />}

      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />

          <div className="layout-page">
            <Nav />

            <div className="content-wrapper">
              <div className="container-fluid flex-grow-1 container-p-y">
                <div className="row">
                  <Master />

                  <div className="col-12">
                    <div className="card">
                      <div className="card-header">
                        <div className="row align-items-center justify-content-between">
                          <div className="col-6">
                            <h5 className="mb-0">Messages List</h5>
                          </div>
                          <div className="col-6 d-flex gap-2 align-items-center justify-content-end">
                            <Link
                              to="/app/configuration"
                              state={{
                                management: "Mobile Application",
                                tab: "student_app_config_workflow",
                              }}
                              className="btn btn-label-secondary"
                            >
                              <i className="ri-smartphone-line me-1"></i>
                              Configuration
                            </Link>

                            <Link
                              to="/message/add"
                              className="btn btn-label-primary"
                            >
                              Message Add
                            </Link>

                            <button
                              className="btn btn-label-info"
                              onClick={handleAppShare}
                            >
                              <i className="ri-share-forward-line me-1"></i>
                              Student App Share
                            </button>
                          </div>
                        </div>
                      </div>

                      <div className="card-body">
                        <div className="table-responsive">
                          <table className="table table-hover">
                            <thead>
                              <tr className="text-nowrap">
                                <th>#</th>
                                <th>Name</th>
                                <th>Slug</th>
                                <th>Push Notification</th>
                                {/* <th>Voice Notification</th> */}
                                <th>Meta WhatsApp Message</th>
                                <th>Last Updated At</th>
                              </tr>
                            </thead>
                            <tbody>
                              {data?.map((item, index) => (
                                <tr key={item.id}>
                                  <td>{index + 1}</td>
                                  <td>{item.name}</td>
                                  <td>
                                    <code>{item.slug}</code>
                                  </td>
                                  <td>
                                    <div className="d-flex gap-1">
                                      <div className="form-check form-switch">
                                        <input
                                          className="form-check-input"
                                          type="checkbox"
                                          role="switch"
                                          id={`push_notification_${item.id}`}
                                          checked={
                                            item.push_notification_status ===
                                            "1"
                                          }
                                          onChange={() =>
                                            handlePushNotificationStatusChange(
                                              item.id,
                                            )
                                          }
                                        />
                                      </div>
                                      <i
                                        className="ri ri-eye-line text-info ri-26px cursor-pointer"
                                        onClick={() => setModalData(item)}
                                        data-bs-toggle="modal"
                                        data-bs-target="#PushNotification"
                                      ></i>

                                      <i
                                        className="ri ri-send-plane-fill text-success ri-26px cursor-pointer"
                                        onClick={() => {
                                          setModalData(item);
                                          setTestPushData({
                                            type: "",
                                            user_id: "",
                                          });
                                        }}
                                        data-bs-toggle="modal"
                                        data-bs-target="#TestPushNotification"
                                      />
                                    </div>
                                  </td>

                                  {/* <td>
                                    <div className="form-check form-switch">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        role="switch"
                                        id={`voice_notification_${item.id}`}
                                        checked={String(item.voice_notification_status) === "1"}
                                        onChange={() =>
                                          handleVoiceNotificationStatusChange(item.id)
                                        }
                                      />
                                    </div>
                                  </td> */}
                                  <td>
                                    <div className="d-flex gap-1">
                                      <div className="form-check form-switch">
                                        <input
                                          className="form-check-input"
                                          type="checkbox"
                                          role="switch"
                                          id={`meta_whatsapp_${item.id}`}
                                          checked={
                                            item.meta_whatsapp_status === "1"
                                          }
                                          onChange={() =>
                                            handleMetaWhatsappStatusChange(
                                              item.id,
                                            )
                                          }
                                        />
                                      </div>
                                      <Link
                                        to={`/message/update?id=${item.id}`}
                                        state={{ data: item }}
                                      >
                                        <i className="ri ri-eye-line text-info ri-26px"></i>
                                      </Link>
                                    </div>
                                  </td>
                                  <td>{formatToDateTime(item.updated_at)}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="PushNotification"
        tabIndex={-1}
        aria-labelledby="PushNotificationLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <form action="" onSubmit={handlePushNotificationUpdate}>
              <div className="modal-header py-3 bg-label-primary">
                <h1 className="modal-title fs-5" id="PushNotificationLabel">
                  Push Notification
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                />
              </div>
              <div className="modal-body">
                <input type="hidden" name="id" value={modalData?.id || ""} />
                <div className="mb-3">
                  <div className="form-floating form-floating-outline">
                    <input
                      type="text"
                      className="form-control input-format-ignore"
                      name="push_notification_header"
                      placeholder="Header"
                      value={modalData?.push_notification_header}
                      onChange={(e) =>
                        setModalData({
                          ...modalData,
                          push_notification_header: e.target.value,
                        })
                      }
                    />
                    <label>Header</label>
                  </div>
                </div>
                <div className="mb-3">
                  <div className="form-floating form-floating-outline">
                    <textarea
                      type="text"
                      className="form-control input-format-ignore"
                      name="push_notification_message"
                      placeholder="Message"
                      value={modalData?.push_notification_message}
                      onChange={(e) =>
                        setModalData({
                          ...modalData,
                          push_notification_message: e.target.value,
                        })
                      }
                    />
                    <label>Message</label>
                  </div>
                </div>
              </div>
              <div className="modal-footer py-3 bg-label-primary">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
                <button type="submit" className="btn btn-primary">
                  Update
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="TestPushNotification"
        tabIndex={-1}
        aria-labelledby="TestPushNotificationLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <form
              onSubmit={(e) => {
                e.preventDefault();
                handleTestPushNotification();
              }}
            >
              <div className="modal-header py-3 bg-label-primary">
                <h5 className="modal-title" id="TestPushNotificationLabel">
                  Test Push Notification {modalData?.slug || ""}
                </h5>

                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                />
              </div>

              <div className="modal-body">
                <div className="mb-3">
                  <div className="form-floating form-floating-outline">
                    <select
                      className="form-select"
                      required
                      value={testPushData.type}
                      onChange={(e) =>
                        setTestPushData({
                          ...testPushData,
                          type: e.target.value,
                        })
                      }
                    >
                      <option value="">Select Type</option>
                      <option value="student">Student</option>
                      <option value="teacher">Teacher</option>
                    </select>

                    <label>Type</label>
                  </div>
                </div>

                <div className="mb-3">
                  <div className="form-floating form-floating-outline">
                    <input
                      required
                      type="number"
                      className="form-control input-format-ignore"
                      placeholder="User ID"
                      value={testPushData.user_id}
                      onChange={(e) =>
                        setTestPushData({
                          ...testPushData,
                          user_id: e.target.value,
                        })
                      }
                    />
                    <label>User ID</label>
                  </div>
                </div>

                <div className="mb-3">
                  <div className="form-floating form-floating-outline">
                    <input
                      type="text"
                      className="form-control"
                      value={modalData?.push_notification_header || ""}
                      readOnly
                    />
                    <label>Title</label>
                  </div>
                </div>

                <div className="mb-0">
                  <div className="form-floating form-floating-outline">
                    <textarea
                      className="form-control"
                      style={{ height: "120px" }}
                      value={modalData?.push_notification_message || ""}
                      readOnly
                    />
                    <label>Message</label>
                  </div>
                </div>
              </div>

              <div className="modal-footer py-3 bg-label-primary">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>

                <button type="submit" className="btn btn-primary">
                  <i className="ri ri-send-plane-fill me-1"></i>
                  Send Test
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
